import { Component } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import AriaModal from 'react-aria-modal';

import { themes } from '../../lib/themes';

import styles from './styles.module.scss';

class Modal extends Component {
  static propTypes = {
    theme: PropTypes.oneOf(themes),
    visible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    focusDialog: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    underlayClickExits: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    showUnderlay: PropTypes.bool,
  };
  static defaultProps = {
    theme: 'waybetter',
    focusDialog: true,
    onClose: () => {},
    onOpen: () => {},
    underlayClickExits: true,
    showUnderlay: true,
  };
  static displayName = 'Modal';

  state = {
    modalActive: false,
    modalHasMounted: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible && !this.props.visible) {
      this.deactivateModal();
    } else if (!prevProps.visible && this.props.visible) {
      this.activateModal();
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.activateModal();
    }
  }

  getApplicationNode = () => document.getElementById('#hub');

  activateModal = () => {
    this.setState({ modalActive: true });
  };

  deactivateModal = () => {
    this.setState(
      {
        modalHasMounted: false,
      },
      () => {
        setTimeout(() => {
          this.setState({
            modalActive: false,
          });
        }, 300);
      }
    );
  };

  onModalEnter = () => {
    this.props.onOpen();
    this.setState({ modalHasMounted: true });
  };

  render() {
    const {
      children,
      title,
      focusDialog,
      onClose,
      className,
      showUnderlay,
      underlayClickExits,
    } = this.props;
    const { modalHasMounted, modalActive } = this.state;

    return (
      <AriaModal
        mounted={modalActive}
        titleText={title}
        focusDialog={focusDialog}
        onExit={onClose}
        onEnter={this.onModalEnter}
        getApplicationNode={this.getApplicationNode}
        underlayClickExits={underlayClickExits}
        underlayColor={false}
        underlayClass={cc([
          styles.underlay,
          {
            [styles.mounted]: modalHasMounted && showUnderlay,
          },
        ])}
        includeDefaultStyles={false}
        dialogClass={cc([
          styles.modal,
          { [styles.mounted]: modalHasMounted },
          className,
        ])}
      >
        <div tabIndex="1">{children}</div>
      </AriaModal>
    );
  }
}

export default Modal;
